import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MenubarDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getElevationStyle
} from "../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../helpers/theme/corner";

export const getMenubarBarPad = ({
    controlHeights
}: {
    controlHeights: NCoreUIKit.ControlHeights;
}): number => {
    return (controlHeights.medium - controlHeights.small) / 2;
};

export const getMenubarPlainOffset = ({
    controlPaddings,
    controlHeights
}: {
    controlPaddings: NCoreUIKit.ControlPaddings;
    controlHeights: NCoreUIKit.ControlHeights;
}): number => {
    return getMenubarBarPad({
        controlHeights
    }) + controlPaddings.small;
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignSelf: "stretch",
        flexShrink: 1,
        minWidth: 0
    },
    bar: {
        flexDirection: "row",
        borderStyle: "solid",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    controlPaddings,
    controlHeights,
    shapeConfigs,
    shadowAlpha,
    elevations,
    radiuses,
    borders,
    variant,
    colors,
    spaces
}: MenubarDynamicStyleType) => {
    const barPad = getMenubarBarPad({
        controlHeights
    });

    const styles = {
        bar: {
            height: controlHeights.medium,
            paddingHorizontal: barPad,
            gap: spaces.spacingXxs
        } as Mutable<ViewStyle>
    };

    if(variant === "plain") {
        styles.bar.marginStart = -getMenubarPlainOffset({
            controlPaddings,
            controlHeights
        });

        return styles;
    }

    Object.assign(styles.bar, {
        ...getCornerStyle({
            radius: radiuses.actions + barPad + borders.line,
            shapeConfigs
        }),
        backgroundColor: colors.content.container.raised,
        borderColor: colors.content.border.subtle,
        borderWidth: borders.line
    });

    if(elevations.level1.length) {
        Object.assign(styles.bar, getElevationStyle({
            shadowColor: colors.system.shadow,
            level: "level1",
            shadowAlpha,
            elevations
        }));
    }

    return styles;
};
export default stylesheet;
